export const PORTFOLIO_INPUT_PLACEHOLDER="For example:\n"+"Apple $3214\n"+"CRM $84154\n"+"VOO $23500\n"+"TSLA #200\n"+"Cash $900";